import type { QuizLevel } from "@lib/domain";

export const LEVEL_NAMES: Record<QuizLevel, string> = {
  1: "Recap",
  2: "Understand",
  3: "Beyond",
};